import TopUpImage from '../../assets/images/topup.webp';
import NumberOneCircleIcon from '../../components/shared/Icons/NumberOneCircleIcon';
import NumberTowCircleIcon from '../../components/shared/Icons/NumberTowCircleIcon';
import NumberThreeCircleIcon from '../../components/shared/Icons/NumberThreeCircleIcon';
import NumberFourCircleIcon from '../../components/shared/Icons/NumberFourCircleIcon';
import NumberFiveCircleIcon from '../../components/shared/Icons/NumberFiveCircleIcon';
import NumberSixCircleIcon from '../../components/shared/Icons/NumberSixCircleIcon';
import InstructionsScreen from '../../components/shared/InstructionsScreen/InstructionsScreen';
import { UrlEvent } from '../../sdk/url.event';

export default function InstapayInstructionsPage({
  organization: organizationCode,
}) {
  return (
    <InstructionsScreen
      image={TopUpImage}
      title="How to add cash with Instapay"
      organizationCode={organizationCode}
      instructions={[
        { icon: <NumberOneCircleIcon />, title: 'Open InstaPay' },
        { icon: <NumberTowCircleIcon />, title: 'Click "send money"' },
        {
          icon: <NumberThreeCircleIcon />,
          title: 'Choose "Card" from the deposit account options',
        },
        {
          icon: <NumberFourCircleIcon />,
          title:
            'Enter your 16 digit {card name} card number, name and deposit amount',
        },
        { icon: <NumberFiveCircleIcon />, title: 'Confirm your Instapay PIN' },
        {
          icon: <NumberSixCircleIcon />,
          title: "That's it! Your deposit will appear on your card account",
        },
      ]}
      cta={{
        text: 'Go to InstaPay',
        onClick: () => {
          UrlEvent.open('https://onelink.to/hg7dp4');
        },
      }}
    />
  );
}
